(function () {
  'use strict';

  function parseZones(raw) {
    var zones = [];
    var defaultZone = null;

    raw.split('\n').forEach(function (line) {
      line = line.trim();
      if (!line) return;
      var match = line.match(/^([^:]+):\s*(\d+)\s*[-–]\s*(\d+)$/);
      if (!match) return;
      var prefix = match[1].trim().toLowerCase();
      var min = parseInt(match[2], 10);
      var max = parseInt(match[3], 10);
      if (prefix === 'default') {
        defaultZone = { min: min, max: max };
      } else {
        zones.push({ prefix: prefix, min: min, max: max });
      }
    });

    zones.sort(function (a, b) { return b.prefix.length - a.prefix.length; });
    return { zones: zones, defaultZone: defaultZone };
  }

  function matchZone(zip, parsed) {
    var normalizedZip = zip.trim().toLowerCase();
    for (var i = 0; i < parsed.zones.length; i++) {
      if (normalizedZip.startsWith(parsed.zones[i].prefix)) {
        return parsed.zones[i];
      }
    }
    return parsed.defaultZone;
  }

  function addDays(date, days, skipWeekends) {
    var result = new Date(date);
    if (!skipWeekends || days === 0) {
      result.setDate(result.getDate() + days);
      return result;
    }
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return result;
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function isValidZip(zip) {
    return /^[A-Za-z0-9][A-Za-z0-9\s\-]{1,9}$/.test(zip.trim());
  }

  function setResult(block, state, message) {
    var el = block.querySelector('.delivery-estimate__result');
    var text = block.querySelector('.delivery-estimate__result-text');
    if (!el || !text) return;
    el.removeAttribute('hidden');
    el.className = 'delivery-estimate__result delivery-estimate__result--' + state;
    text.textContent = message;
  }

  function check(block) {
    var input = block.querySelector('.delivery-estimate__input');
    if (!input) return;

    var zip = input.value.trim();

    if (!isValidZip(zip)) {
      setResult(block, 'error', 'Please enter a valid zip code.');
      return;
    }

    var rawZones = block.dataset.zones || '';
    var skipWeekends = block.dataset.skipWeekends !== 'false';
    var parsed = parseZones(rawZones);
    var zone = matchZone(zip, parsed);

    if (!zone) {
      setResult(block, 'error', 'No estimate available for this zip code.');
      return;
    }

    var today = new Date();
    var earliest = addDays(today, zone.min, skipWeekends);
    var latest = addDays(today, zone.max, skipWeekends);

    var message =
      zone.min === zone.max
        ? 'Arrives by ' + formatDate(earliest)
        : 'Arrives ' + formatDate(earliest) + ' – ' + formatDate(latest);

    setResult(block, 'success', message);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.delivery-estimate__btn');
    if (!btn) return;
    check(btn.closest('.delivery-estimate'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('.delivery-estimate__input');
    if (!input) return;
    check(input.closest('.delivery-estimate'));
  });
})();
